import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

import { useStyles } from './InfoField.styles';

const EMPTY_PLACEHOLDER = '—';

export interface InfoFieldProps {
    label: string;
    value?: string | number | null;
    /** Optional element rendered next to the value (e.g. an external link button). */
    action?: ReactNode;
    /** Override the em-dash shown when value is null/empty. */
    emptyPlaceholder?: string;
    automationId?: string;
}

/**
 * Read-only labeled value with consistent typography across detail pages.
 * Falls back to an em-dash in muted text when the value is null/empty.
 */
export const InfoField = ({
    label,
    value,
    action,
    emptyPlaceholder = EMPTY_PLACEHOLDER,
    automationId,
}: InfoFieldProps) => {
    const { classes, cx } = useStyles();
    const hasValue = value !== null && value !== undefined && value !== '';

    return (
        <Box className={classes.root} automation-id={automationId}>
            <Typography component="span" className={classes.label}>
                {label}
            </Typography>
            <Box className={classes.valueRow}>
                <Typography
                    variant="body1"
                    component="span"
                    className={cx(classes.value, !hasValue && classes.empty)}
                    automation-id={automationId ? `${automationId}-value` : undefined}
                >
                    {hasValue ? value : emptyPlaceholder}
                </Typography>
                {action}
            </Box>
        </Box>
    );
};
